module.exports = __webpack_public_path__ + "img/6_uk.ea3a523f.svg";